export type Purchase = {
  name: string
  city: string
  state: string
}

/**
 * SAMPLE DATA. Only switch the notifications on (ENABLED in
 * PurchaseNotifications.tsx) once this list comes from real orders.
 */
export const recentPurchases: Purchase[] = [
  { name: 'Ashley M.', city: 'Austin', state: 'Texas' },
  { name: 'Brittany K.', city: 'Tampa', state: 'Florida' },
  { name: 'Jessica R.', city: 'Denver', state: 'Colorado' },
  { name: 'Megan T.', city: 'Charlotte', state: 'North Carolina' },
  { name: 'Danielle P.', city: 'Scottsdale', state: 'Arizona' },
  { name: 'Courtney S.', city: 'Nashville', state: 'Tennessee' },
  { name: 'Lauren B.', city: 'Atlanta', state: 'Georgia' },
  { name: 'Kayla W.', city: 'San Diego', state: 'California' },
  { name: 'Amanda G.', city: 'Minneapolis', state: 'Minnesota' },
  { name: 'Rachel D.', city: 'Louisville', state: 'Kentucky' },
  { name: 'Tiffany H.', city: 'St. Louis', state: 'Missouri' },
  { name: 'Whitney L.', city: 'Raleigh', state: 'North Carolina' },
]
